/**
 * Get the image url from the storage.versepen.ai. 
 * Need to change root url if we want to use a different storage.
 * 
 * @param url - The url of the image
 * @param width - The width of the image
 * @returns The image url
 */
export function getImageUrl(
  url: string,
  width: number = 1920,
  quality = 75,
  format: 'auto' | 'jpeg' | 'webp' | 'avif' = 'auto',
) {
  return `https://storage.deepguide.ai/cdn-cgi/image/format=${format},quality=${quality},fit=scale-down,width=${width}/${url}`;
}
